import { api } from '../../../services/api';

class FeedService {
	constructor() {
		this.Api = api;
		this.limit = 500;
	}

	queryFeedDifferenceCounts(merchantId) {
		const endpoint = `/api/v0/merchant_feed/${merchantId}/difference_counts/`;
		return this.Api.get(endpoint).then((resp) => {
			const stats = resp.data.data.length ? resp.data.data[0] : [];
			return {stats: stats[merchantId]};
		});
	}

	queryFeedDiferencesByField(merchantId, fieldName) {
		const endpoint = `/api/v0/merchant_feed/${merchantId}/${fieldName}/differences/`;
		return this.Api.get(endpoint).then((resp) => {
			const stats = resp.data.data.length ? resp.data.data[0] : [];
			return {stats: stats[fieldName]};
		});
	}

	queryMerchantInfo() {
		return this.Api.get(`/api/v0/merchants/`).then((resp) => {
			const info = resp.data.data.length ? resp.data.data : [];
			return {merchants: info};
		});
	}
}

export default new FeedService();
